// =========================
// SOAP GENERATOR
// =========================

export const generarSOAPPeriodontal = ({

  paciente,

  historiaClinica,

  clasificacion,

  riesgo,

  tratamiento,

  periodonto

}) => {

  // =========================
  // S
  // =========================

  const subjetivo = [];

  if (
    historiaClinica
      ?.motivoConsulta
  ) {

    subjetivo.push(

      historiaClinica
        .motivoConsulta
    );
  }

  if (
    historiaClinica
      ?.habitos
      ?.tabaquismo
  ) {

    subjetivo.push(
      "Paciente refiere hábito tabáquico."
    );
  }

  if (
    historiaClinica
      ?.habitos
      ?.bruxismo
  ) {

    subjetivo.push(
      "Paciente refiere bruxismo."
    );
  }

  // =========================
  // O
  // =========================

  const datos =
    periodonto?.datos || {};

  const profundidades =
    Object.values(datos)

      .map(v => Number(v))

      .filter(v => v > 0);

  const promedio =

    profundidades.length

      ? (

          profundidades.reduce(
            (a,b)=>a+b,
            0
          ) / profundidades.length

        ).toFixed(2)

      : 0;

  const objetivo = [

    `Profundidad promedio de sondaje: ${promedio} mm.`,

    `Clasificación periodontal: ${clasificacion.dx}.`,

    `Riesgo periodontal: ${riesgo.riesgo}.`
  ];

  // =========================
  // A
  // =========================

  const analisis = [

    `Paciente con diagnóstico compatible con ${clasificacion.dx.toLowerCase()}.`,

    `Factores de riesgo identificados: ${riesgo.factores.join(", ")}.`

  ];

  // =========================
  // P
  // =========================

  const plan = [];

  tratamiento.plan.forEach(f => {

    f.procedimientos
      .forEach(p => {

        plan.push(p);
      });
  });

  return {

    subjetivo,

    objetivo,

    analisis,

    plan
  };
};